import * as angular from 'angular';
import 'angular-ui-router';
import { SubheaderListController } from '../../../navbar/subheader/SubheaderListController';
import { MarketplaceStepController } from '../create/MarketplaceStepController';
import MarketplaceStepCreationView from './../create/MarketplaceStepCreationView.html';
import MarketplaceStepView from './../create/MarketplaceStepView.html';
import { ListMarketplaceController } from './ListMarketplaceController';
import ListMarketplaceView from './ListMarketplaceView.html';
import { NoTemplatesFoundComponent } from './noTemplatesFound/noTemplatesFound.component';
import SubheaderListView from './subheader/SubheaderListView.html';
export const marketplaceListStateName = 'auth.marketplace.list';
export const marketplaceCreateStateName = 'auth.marketplace.create';
export const marketplaceCreateSkillStateName = 'auth.marketplace.create.skill';
export default angular
    .module('marketplace.list', ['ui.router'])
    .controller('ListMarketplaceController', ListMarketplaceController)
    .component('noTemplatesFound', NoTemplatesFoundComponent)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(marketplaceListStateName, {
            url: '/marketplace?tenant-invitation&tenantName&from',
            views: {
                'subheader@auth': {
                    template: SubheaderListView,
                    controller: SubheaderListController,
                    controllerAs: '$ctrl',
                },
                '@auth.marketplace': {
                    template: ListMarketplaceView,
                    controller: ListMarketplaceController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state(marketplaceCreateStateName, {
            abstract: true,
            views: {
                '@': {
                    template: MarketplaceStepView,
                    controller: MarketplaceStepController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state(marketplaceCreateSkillStateName, {
            url: '/marketplace/create?templateIdentity&origin',
            template: MarketplaceStepCreationView,
        });
    }]).name;
